// src/components/BookCover/VersionFrontThumbnail.jsx
// Renders a small front-cover preview for a version. Uses, in order of preference:
//   1. version.cover_url (a server-rendered cover image — only set after explicit save)
//   2. an off-screen Fabric render of version.wraparoundDesign cropped to the front face
//   3. a placeholder (Edit icon if a design exists, Add icon if blank)

import React from 'react';
import { Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import useVersionFrontThumbnail from '../../hooks/useVersionFrontThumbnail';

export default function VersionFrontThumbnail({ version, width = 32, height = 44 }) {
  const renderedUrl = useVersionFrontThumbnail(
    version?.cover_url ? null : version,
    { targetWidth: Math.max(120, width * 4) },
  );

  const baseSx = {
    width, height, borderRadius: 0.5,
    border: '1px solid #e0e0e0',
    flexShrink: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    color: '#9ca3af',
    overflow: 'hidden',
  };

  const previewUrl = version?.cover_url || renderedUrl;
  if (previewUrl) {
    return (
      <Box sx={baseSx}>
        <img
          src={previewUrl}
          alt={version?.name || ''}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </Box>
    );
  }

  const hasAnyDesign = version?.hasDesign || version?.hasWraparoundDesign || !!version?.wraparoundDesign;
  return (
    <Box sx={baseSx}>
      {hasAnyDesign
        ? <EditIcon sx={{ fontSize: width * 0.5, opacity: 0.5 }} />
        : <AddIcon sx={{ fontSize: width * 0.5, opacity: 0.3 }} />}
    </Box>
  );
}
